import script from "./StepAssetType.vue?vue&type=script&setup=true&lang=js"
export * from "./StepAssetType.vue?vue&type=script&setup=true&lang=js"

import "./StepAssetType.vue?vue&type=style&index=0&id=1aa7ed6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aa7ed6f"]])

export default __exports__